import EventEmitter from "../globalFunctions/EventEmitter";
import parseJSON    from './parseJSON';

const { VUE_APP_NOTIFICATIONS_URL } = process.env;

const eventEmitter = new EventEmitter();
let _apiUrl = VUE_APP_NOTIFICATIONS_URL;
let _ws = null;
// let _onChangeStateCallback = null;
let _token = null;
let _forceClosed = false;
let _lastState = null;
let _lastId = null;

// export const onChangeState = ( onChangeStateCallback ) => _onChangeStateCallback = onChangeStateCallback;
export const onMessage = ( callback ) => eventEmitter.on('event', callback);
export const setToken = ( token ) => {
  _token = token ? `Bearer ${token}` : null;
  auth();
};
export const setNotificationsUrl = ( apiUrl ) => _apiUrl = apiUrl;

export const init = () => createChannel();

const send = ( method, params ) => _ws.send(JSON.stringify({ method, params }));

const auth = () => {
  if (!_ws || _ws.readyState !== WebSocket.OPEN || !_token) return;
  // console.log(`[EVENTS] auth with token "${_token}"`);
  send('setAuth', { token: _token });
};

const changeState = ( state ) => {
  if (_lastState === state) return;
  _lastState = state;
  // if (_onChangeStateCallback) _onChangeStateCallback(state);
};

const createChannel = () => {
  close();
  const url = _apiUrl;
  console.log(`[EVENTS] create at url: ${url}`);
  _ws = new WebSocket(url);
  _ws.onopen = () => {
    console.log(`[EVENTS] open`);
    changeState('online');
    auth();
  };
  _ws.onclose = () => {
    if (_forceClosed) {
      _forceClosed = false;
      return;
    }
    _ws = null;
    console.log(`[EVENTS] close`);
    changeState('offline');
    setTimeout(createChannel, 3000);
  };
  _ws.onerror = ( e ) => {
    // console.log(`[EVENTS] error`, e);
    // setTimeout(createChannel, 3000);
  };
  _ws.onmessage = ( message ) => {
    // console.log(`[EVENTS] message: `, message.data);
    const json = parseJSON(message.data);
    if (!json) return;
    const { id, data } = json;
    if (data.key === 'AUTH') {
      if (_lastId) send('getHistory', { fromId: _lastId });
    } else {
      eventEmitter.emit('event', data);
    }
    if (id) _lastId = id;
  };
};

const close = () => {
  if (!_ws) return;
  _forceClosed = true;
  _ws.close();
};
